/**
 * 작성자 : 홍선영
 * 날짜 : 2024.12.23
 * 경로 : 사내관리-안전관리/게시판관리
 */

import Tab from '../../components/Tab';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { IUser, pageInfoState, userState } from '../../atoms';
import { useEffect, useState } from 'react';
import { ITabObject } from 'customTypes';
import Transfer from '../s_safe/safe4/transfer';
import Mainpoint from '../s_safe/safe4/mainpoint';
import Correct from './company2/correct';

const CCompany2 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
  const renderPage = () => {
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <Transfer type='c' />; // (현장) 현장 전달사항 / (사내) 긴급 공지사항
        case '002':
          return <Correct />; // 시정 사항
        case '003':
          return <div>준비중입니다</div>;
        case '004':
          return <div>준비중입니다</div>;
        case '005':
          return <div>준비중입니다</div>;
        case '006':
          return <Mainpoint type='c' />; // 안전 중점사항
        default:
          return <div>준비중입니다</div>;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default CCompany2;
